import React, { Component } from 'react'
import PropTypes from 'prop-types'
import './ParallaxSplit.css'
import image1 from './fruitbar-bucket.jpg'
import image2 from './strawberry-bowl.jpg'
import { Link } from 'react-router-dom'

/**
 * Hero Component
 */
export default class ParallaxSplit extends Component {
  /**
   * Default props.
   *
   * @type {{parallaxTitle: string, parallaxSubTitle: string, parallaxIntro: string}}
   */
  static defaultProps = {
    parallaxTitle1: '',
    parallaxSubTitle1: '',
    parallaxTitle2: 'With something for everyone',
    parallaxSubTitle2: ''
  }

  /**
   * Prop Types
   *
   * @type {{}}
   */
  static propTypes = {
    parallaxTitle1: PropTypes.string,
    parallaxSubTitle1: PropTypes.string
  }

  /**
   * Render
   *
   * @returns {XML}
   */
  render() {
    const { parallaxTitle2 } = this.props

    return (
      <section className="ParallaxSplit Parallax__group--split ZIndex__group--fore Group2">
        {/* <header>
                    <h2>The Solero<sup>®</sup> Story</h2>
                </header> */}

        <div className="Parallax__layer Parallax__layer--base">
          <header>
            <p>
              Our crushed fruit bars and pops are made with sweet, sun-ripened fruit, carefully crushed, blended and
              frozen to cool, flavor packed perfection.
            </p>
            <p>
              To make these real cream bars, we carefully blend sweet cream into our special recipes, and freeze them to
              cool, flavor-packed perfection.
            </p>
            <Link to="/our-products" className="btn">
              View our products
            </Link>
          </header>
        </div>

        <div className="Parallax__layer Parallax__layer--fore">
          <figure>
            <img src={image1} alt="" />
          </figure>
        </div>

        <div className="Parallax__layer Parallax__layer--base">
          <header>
            <h3>{parallaxTitle2}</h3>
            <p>
              Solero offers four lines, ranging between 40 - 120 calories per bar or pop:
              <ul>
                <li>Solero® Indulgent Cream Bars</li>
                <li>Solero® Organic Crushed Fruit Bars</li>
                <li>Solero® Natural Crushed Fruit Pops</li>
                <li>Solero® Natural Crushed Fruit Bars</li>
              </ul>
            </p>
            {/*<Button buttonText="Find where to buy"
                                link="/where-to-buy"/>*/}
            <Link to="/where-to-buy" className="btn">
              Find where to buy
            </Link>
          </header>
        </div>

        <div className="Parallax__layer Parallax__layer--fore">
          <figure>
            <img src={image2} alt="" />
          </figure>
        </div>
      </section>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/page/parallaxSplit/ParallaxSplit.jsx